import { render, staticRenderFns } from "./PuzzleEdit.vue?vue&type=template&id=d1a77650&"
import script from "./PuzzleEdit.vue?vue&type=script&lang=js&"
export * from "./PuzzleEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports